// 매출 변경이력 — 칸 이름 한국어와 표 이름 정리. auditDiff.js 에서 옮김(2026-11-05, 300줄 규칙).
//   기록은 등록 때 paymentDate 모양, 수정·삭제 때 payment_date 모양으로 남아 둘 다 적는다.
//   담당자·세금계산서 번호는 서버가 userId·taxInvoiceId 이름으로 바꿔 준다(services/revenue/audit.js).

/** 테이블별 필드명 → 한국어 레이블 매핑 */
export const TABLE_FIELD_LABELS = {
  revenue_payments: {
    paymentDate: '입금일자', payment_date: '입금일자', amount: '금액',
    payerName: '입금자', payer_name: '입금자',
    userId: '마케터', taxInvoiceId: '세금계산서', note: '비고',
  },
  revenue_tax_invoices: {
    issueDate: '발행일자', issue_date: '발행일자', issueType: '구분', issue_type: '구분',
    supplyAmount: '공급가액', supply_amount: '공급가액', taxAmount: '세액', tax_amount: '세액',
    totalAmount: '발행금액', total_amount: '발행금액', customerName: '상호', customer_name: '상호',
    bizNo: '사업자번호', biz_no: '사업자번호', issueId: '발행번호', issue_id: '발행번호',
    userId: '마케터', note: '비고',
  },
  revenue_card_phone_approvals: {
    paymentDate: '결제일', payment_date: '결제일', cardCompany: '카드사', card_company: '카드사',
    amount: '금액', installmentMonths: '할부', installment_months: '할부',
    userId: '마케터', note: '비고',
  },
  revenue_others: {
    date: '날짜', amount: '금액', description: '내용',
    userId: '마케터', note: '비고',
  },
  revenue_card_approvals: {
    transactionDate: '거래일', transactionAmount: '거래금액',
    approvalNo: '승인번호', cardIssuer: '카드사', terminalId: '단말기',
    fee: '수수료', expectedPaymentAmount: '입금예정액', expectedPaymentDate: '입금예정일',
    revenueType: '정산상태', revenue_type: '정산상태', transactionType: '거래유형', transaction_type: '거래유형',
  },
};

/** DOT·회사 표 이름을 본사 이름으로 — 칸이 같아 같은 이름표·같은 문장을 쓴다 */
export function auditBaseTable(tableName) {
  return String(tableName || '').replace(/^(dot_revenue_|revenue_dot_|ext_revenue_)/, 'revenue_');
}
